import { createSelector } from '@ngrx/store';

import { PrismicImageData } from '@app-model/api';

import { State } from '../reducers';

const selectPrismicState = (state: State) => state.prismicState;
const selectPrismicData = createSelector(selectPrismicState, (state) => state && state.data);
export const selectLoginPageLogoLeft = createSelector(selectPrismicData, (data) => data && data.login_page_logo_left);
export const selectLoginPageLogoMiddle = createSelector(
  selectPrismicData,
  (data) => data && data.login_page_logo_middle
);
export const selectLoginWarning = createSelector(selectPrismicData, (data) => data && data.login_warning);
export const selectLoginPageLogoRight = createSelector(selectPrismicData, (data) => data && data.login_page_logo_right);
export const selectLoginPageBackground = createSelector(
  selectPrismicData,
  (data) => data && data.login_page_background
);
export const selectSmallLogo = createSelector(selectPrismicData, (data) => data && data.small_logo);
export const selectHomeViewActionImage = createSelector(
  selectPrismicData,
  (data) => data && data.home_view_action_image
);
export const selectProductsPrismicData = createSelector(selectPrismicData, (data) => data && data.products);
export const selectProductImage = (category: string) =>
  createSelector(selectProductsPrismicData, (products) => {
    const match =
      category && products?.find((product) => product.product_code.map((code) => code.text).includes(category));

    return match
      ? match.product_image
      : ({ url: 'assets/no-product-placeholder.jpg', alt: 'No product placeholder' } as PrismicImageData);
  });
